import { BooleanValueProperty } from './properties/boolean-property.model';
import { TextProperty } from './properties/text-property.model';
import { Widget } from './form-widget.model';

export class FbMatrixWidget extends Widget {
  constructor(data: any = {}) {
    super(data);
    this.title = 'Table';
    this.name = 'fb-matrix';
    this.properties = this.defaultProperties(data.properties);
  }

  defaultProperties(props: any) {
    const properties = this.getProperties(props || {});
    return properties;
  }

  getProperties(props: any = {}) {
    const properties = {
      text: new TextProperty({
        value: props.text ? props.text.value : 'Table 1',
      }),
      content: new TextProperty({
        title: props.content ? props.content.title : 'Description',
        value: props.content ? props.content.value : '',
        placeholder: props.content?.placeholder
          ? props.content?.placeholder
          : 'Add a description or, leave blank',
      }),
      hideLabel: new BooleanValueProperty({
        value: props.hideLabel ? props.hideLabel.value : true,
      }),
      hideHeader: new BooleanValueProperty({
        value: props.hideLabel ? props.hideLabel.value : true,
      }),
      hideBorder: new BooleanValueProperty({
        value: props.hideLabel ? props.hideLabel.value : true,
      }),
      cols: props.cols || { value: [] },
      rows: props.rows || { value: [] },
      required: new BooleanValueProperty(props.required || { title: 'Required' }),
    };

    // backward compatibility for radio buttons
    properties.rows.value.forEach((item) => {
      item.properties.selected = item.properties.selected
        ? item.properties.selected
        : { title: 'Selected', value: -1 };
    });

    return properties;
  }

  isValid(): boolean {
    if (!this.isRequired()) {
      return true;
    }

    const rows = this.properties.rows.value;

    if (!rows) {
      return false;
    }

    return rows.every((row: any) => {
      const raw = row.properties.selected;
      const value = raw && typeof raw === 'object' && 'value' in raw ? raw.value : raw;
      return value != null && value !== -1;
    });
  }
}
